module.exports = __webpack_public_path__ + "static/media/meta-cover-lightblue.9a1cd0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meta-cover-lightblue.png
// module id = 138
// module chunks = 0